export default class Viewport {
    constructor() {
        this.init();
    }

    init() {
        let elements = document.querySelectorAll( '[data-viewport]' );

        const options = { 
            threshold: 0.1,
            rootMargin: '0px'
        }

        let observer = new IntersectionObserver( this.callback, options);

        elements.forEach( ( element ) => {
            observer.observe( element ); 
        } );
    }

    callback( entries, observer ) {
        entries.forEach( ( entry ) => {
            if ( entry.isIntersecting ) {
                entry.target.classList.add( 'visible' );
                observer.unobserve( entry.target );
            }
        } );
    }
}